import { Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useState } from "react";
import { Loader } from "../../../Shared/Common/Loader";
import useLang from "Shared/hooks/useLanguage";
import { ArrowDown, ArrowUp } from "../../../Shared/Icons";
import { inputs } from "../../../Utils/Compendium/Inputs";
import useIsMobile from "Shared/hooks/useIsMobile";
import CustomPagination from "../../../Shared/JsxPagination";
import ReportDisclaimerNavber from "./ReportDisclaimerNavber";
import ReportDisclaimerRow from "./Row";

function ReportDisclaimerGrid({
  Edit,
  sort,
  check,
  total,
  values,
  errors,
  panels,
  curPage,
  request,
  loading,
  sports2,
  prevPage,
  nextPage,
  loadData,
  pageSize,
  showPage,
  setValues,
  setPanels,
  openModal,
  setErrors,
  searchRef,
  setSorting,
  totalPages,
  setSports2,
  handleSort,
  setRequest,
  setPageSize,
  pageNumbers,
  handleOpen,
  setCurPage,
  modalheader,
  setOpenModal,
  statusChange,
  handleSubmit,
  searchRequest,
  selectedPanels,
  handleOnChange,
  editGridHeader,
  PanelSetupList,
  NavigatorsArray,
  setSearchRequest,
  setSelectedPanels,
  setEditGridHeader,
  disableSavebutton,
  setPanelSetupList,
  disableDeletebutton,
  setTriggerSearchData,
  reportDisclaimerData,
  initialSearchRequestObj,
  DeleteReportDisclaimerById,
}: any) {
  const { t } = useLang();
  const isMobile = useIsMobile();

  // ********** DROPDOWN START *********
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  // ******** DROPDOWN END ***********
  const [open, setOpen] = useState<any>(false);
  return (
    <>
      <ReportDisclaimerNavber
        open={open}
        Inputs={inputs}
        values={values}
        errors={errors}
        panels={panels}
        request={request}
        sports2={sports2}
        setOpen={setOpen}
        loadData={loadData}
        openModal={openModal}
        setValues={setValues}
        setErrors={setErrors}
        setPanels={setPanels}
        handleOpen={handleOpen}
        setRequest={setRequest}
        setSports2={setSports2}
        setSorting={setSorting}
        setCurPage={setCurPage}
        modalheader={modalheader}
        handleSubmit={handleSubmit}
        setOpenModal={setOpenModal}
        searchRequest={searchRequest}
        PanelSetupList={PanelSetupList}
        editGridHeader={editGridHeader}
        selectedPanels={selectedPanels}
        handleOnChange={handleOnChange}
        NavigatorsArray={NavigatorsArray}
        setSearchRequest={setSearchRequest}
        AddBtnText={t("Add Report Disclaimer")}
        setSelectedPanels={setSelectedPanels}
        disableSavebutton={disableSavebutton}
        setPanelSetupList={setPanelSetupList}
        setEditGridHeader={setEditGridHeader}
        setTriggerSearchData={setTriggerSearchData}
        initialSearchRequestObj={initialSearchRequestObj}
      />
      <div className="app-content flex-column-fluid">
        <div className="app-container container-fluid">
          <div className="card">
            <div className="card-body py-2">
              <div className="d-flex align-items-center mb-2 justify-content-center justify-content-sm-start">
                <span className="fw-400 mr-3">{t("Records")}</span>
                <select
                  id={`ReportDisclaimerRecords`}
                  className="form-select w-125px h-33px rounded py-2"
                  data-kt-select2="true"
                  data-placeholder={t("Select option")}
                  data-dropdown-parent="#kt_menu_63b2e70320b73"
                  data-allow-clear="true"
                  onChange={(e) => {
                    setPageSize(parseInt(e.target.value));
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="50" selected>
                    50
                  </option>
                  <option value="100">100</option>
                </select>
              </div>
              <Box sx={{ height: "auto", width: "100%" }}>
                <div className="table_bordered overflow-hidden">
                  <TableContainer
                    sx={
                      isMobile
                        ? {
                            overflowY: "hidden",
                          }
                        : {
                            maxHeight: 428,
                            "&::-webkit-scrollbar": {
                              width: 7,
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "#fff",
                            },
                            "&:hover": {
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "var(--kt-gray-400)",
                                borderRadius: 2,
                              },
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "var(--kt-gray-400)",
                              borderRadius: 2,
                            },
                          }
                    }
                    component={Paper}
                    className="shadow-none"
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table collapsible"
                      className="table table-cutome-expend table-bordered table-head-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
                    >
                      <TableHead className="h-40px">
                        <TableRow>
                          <TableCell style={{ width: "49px" }}></TableCell>
                          <TableCell style={{ width: "49px" }}>
                            {t("Actions")}
                          </TableCell>
                          <TableCell
                            className="min-w-200px"
                            sx={{ width: "max-content" }}
                          >
                            <div
                              onClick={() => handleSort("reqTypeName")}
                              className="d-flex justify-content-between cursor-pointer"
                              id=""
                              ref={searchRef}
                            >
                              <div style={{ width: "max-content" }}>
                                {t("Requisition Type")}
                              </div>

                              <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                                <ArrowUp
                                  CustomeClass={`${
                                    sort.sortingOrder === "desc" &&
                                    sort.clickedIconData === "reqTypeName"
                                      ? "text-success fs-7"
                                      : "text-gray-700 fs-7"
                                  }  p-0 m-0 "`}
                                />
                                <ArrowDown
                                  CustomeClass={`${
                                    sort.sortingOrder === "asc" &&
                                    sort.clickedIconData === "reqTypeName"
                                      ? "text-success fs-7"
                                      : "text-gray-700 fs-7"
                                  }  p-0 m-0`}
                                />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell
                            className="min-w-200px"
                            sx={{ width: "max-content" }}
                          >
                            <div
                              onClick={() => handleSort("panelName")}
                              className="d-flex justify-content-between cursor-pointer"
                              id=""
                              ref={searchRef}
                            >
                              <div style={{ width: "max-content" }}>
                                {t("Panel Name")}
                              </div>

                              <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                                <ArrowUp
                                  CustomeClass={`${
                                    sort.sortingOrder === "desc" &&
                                    sort.clickedIconData === "panelName"
                                      ? "text-success fs-7"
                                      : "text-gray-700 fs-7"
                                  }  p-0 m-0 "`}
                                />
                                <ArrowDown
                                  CustomeClass={`${
                                    sort.sortingOrder === "asc" &&
                                    sort.clickedIconData === "panelName"
                                      ? "text-success fs-7"
                                      : "text-gray-700 fs-7"
                                  }  p-0 m-0`}
                                />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell
                            className="min-w-100px text-center"
                            sx={{ width: "max-content" }}
                          >
                            <div
                              onClick={() => handleSort("isactive")}
                              className="d-flex justify-content-between cursor-pointer"
                              id=""
                              ref={searchRef}
                            >
                              <div style={{ width: "max-content" }}>
                                {t("Inactive/Active")}
                              </div>

                              <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                                <ArrowUp
                                  CustomeClass={`${
                                    sort.sortingOrder === "desc" &&
                                    sort.clickedIconData === "isactive"
                                      ? "text-success fs-7"
                                      : "text-gray-700 fs-7"
                                  }  p-0 m-0 "`}
                                />
                                <ArrowDown
                                  CustomeClass={`${
                                    sort.sortingOrder === "asc" &&
                                    sort.clickedIconData === "isactive"
                                      ? "text-success fs-7"
                                      : "text-gray-700 fs-7"
                                  }  p-0 m-0`}
                                />
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {loading ? (
                          <TableCell colSpan={6} className="">
                            <Loader />
                          </TableCell>
                        ) : (
                          reportDisclaimerData?.map((item: any, key: any) => (
                            <ReportDisclaimerRow
                              key={key}
                              item={item}
                              Edit={Edit}
                              check={check}
                              panels={panels}
                              setOpen={setOpen}
                              sports2={sports2}
                              loadData={loadData}
                              setPanels={setPanels}
                              setSports2={setSports2}
                              handleClose={handleClose}
                              statusChange={statusChange}
                              selectedPanels={selectedPanels}
                              setSelectedPanels={setSelectedPanels}
                              disableDeletebutton={disableDeletebutton}
                              DeleteReportDisclaimerById={
                                DeleteReportDisclaimerById
                              }
                            />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                {/* ==========================================================================================
                    //====================================  PAGINATION START =====================================
                    //============================================================================================ */}
                <CustomPagination
                  curPage={curPage}
                  nextPage={nextPage}
                  pageNumbers={pageNumbers}
                  pageSize={pageSize}
                  prevPage={prevPage}
                  showPage={showPage}
                  total={total}
                  totalPages={totalPages}
                />
                {/* ==========================================================================================
                    //====================================  PAGINATION END =====================================
                    //============================================================================================ */}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportDisclaimerGrid;
